// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.logo-img {\n\tbackground: transparent !important;\n}\n@media (min-width: 992px) {\n.navbar-search-form-mobile,\n\t.nav-mobile-menu {\n\t\tdisplay: none;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
